import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PopupWrapper from '../../../../components/popup/PopupWrapper';
import { getButtonClass } from '../../../../components/popup/popupUtils';
import { formatAllianceMemberRoleLabel } from '../alli/members/allianceMemberRoleLabels';

const ROLE_OPTIONS_FULL = ['Consortium Owner', 'PI', 'Researcher', 'Observer'];

/**
 * 멤버 역할 변경 공통 팝업
 * config.initialData: { member, isOnlyOwner }
 * onClose(submit, { selectedRole })
 */
const MemberRoleChangePopup = ({ config, onClose }) => {
  const { t } = useTranslation();
  const { member, isOnlyOwner } = config?.initialData || {};
  const [selectedRole, setSelectedRole] = useState(member?.role || '');
  const [blockMessage, setBlockMessage] = useState('');

  useEffect(() => {
    if (member?.role) setSelectedRole(member.role);
  }, [member?.role]);

  const handleCancel = () => onClose(false);
  const handleConfirm = () => {
    if (member?.role === 'Consortium Owner' && selectedRole !== 'Consortium Owner') {
      setBlockMessage(t('popup.memberRoleChange.lastOwnerError'));
      return;
    }
    onClose(true, { selectedRole });
  };

  if (!member) return null;

  return (
    <PopupWrapper
      config={{
        ...config,
        title: t('popup.memberRoleChange.title', { name: member.name }),
        width: config?.width ?? 420,
        leftButton: { text: t('popup.common.cancel'), color: 'btn-secondary', submit: false },
        rightButton: { text: t('popup.memberRoleChange.confirm'), color: 'btn-primary', submit: true },
      }}
      onClose={onClose}
      displayType={config?.displayType || 'modal'}
      className="popup-member-role-change"
    >
      <div className="main-popup-body">
        <p className="small text-muted mb-3">{t('popup.memberRoleChange.subtitle')}</p>
        <p className="small mb-3">
          {t('popup.memberRoleChange.currentRole')}: <strong>{formatAllianceMemberRoleLabel(member.role)}</strong>
        </p>
        <p className="small fw-medium mb-2">{t('popup.memberRoleChange.selectRole')}</p>
        {ROLE_OPTIONS_FULL.map((r) => (
          <div key={r} className="form-check">
            <input
              type="radio"
              name="roleChange"
              id={`role-${r}`}
              className="form-check-input"
              checked={selectedRole === r}
              onChange={() => { setSelectedRole(r); setBlockMessage(''); }}
            />
            <label className="form-check-label" htmlFor={`role-${r}`}>
              {formatAllianceMemberRoleLabel(r)} {member.role === r ? t('popup.common.currentMark') : ''}
            </label>
          </div>
        ))}
        {selectedRole === 'Consortium Owner' && member.role !== 'Consortium Owner' && isOnlyOwner && (
          <p className="small text-info mt-2 mb-0">{t('popup.memberRoleChange.ownerDemoteNotice')}</p>
        )}
        {blockMessage && <p className="small text-danger mt-2 mb-0">{blockMessage}</p>}
      </div>
      <div className="main-popup-footer d-flex justify-content-between">
        <button type="button" className={`btn main-popup-left-btn ${getButtonClass('btn-secondary')}`} onClick={handleCancel}>
          {t('popup.common.cancel')}
        </button>
        <button type="button" className={`btn main-popup-right-btn ${getButtonClass('btn-primary')}`} onClick={handleConfirm}>
          {t('popup.memberRoleChange.confirm')}
        </button>
      </div>
    </PopupWrapper>
  );
};

export default MemberRoleChangePopup;
